import ChartSeriesProps from './Series'
import Vue from 'vue'

let KendoChartSeriesItem = {
    name: 'kendo-chart-series-item',
    render () {
        return Vue.prototype._e
    },
    mixins: [ChartSeriesProps]
}

export default KendoChartSeriesItem


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartSeriesItem/index.js